module.exports = __webpack_public_path__ + "static/media/requiring-staff.5e2eb46d.png";